<div class="flex-col height100p">
    <sm-toolbar>
        <p-button *ngFor="let actionButton of actionButtons" icon="fas fa-run" [label]="actionButton.getCaption(text)" (onClick)="run(actionButton)"></p-button>
    </sm-toolbar>
    <textarea pInputTextarea spellcheck=false class="flex-item-fill overflow-y-auto height100p monospace no-resize" [(ngModel)]="text" (ngModelChange)="textChanged()"></textarea>
</div>
